import { useSelector } from 'react-redux';

type InputType =
  | 'active'
  | 'avatar'
  | 'created'
  | 'createdBy'
  | 'credentials'
  | 'currentPermissions'
  | 'currentRoles'
  | 'discipline'
  | 'email'
  | 'emailVerified'
  | 'enableClockInOut'
  | 'enablePayRate'
  | 'enablePaycom'
  | 'enablePto'
  | 'enableTherapistImport'
  | 'firstName'
  | 'lastName'
  | 'licenseNumber'
  | 'modified'
  | 'modifiedBy'
  | 'phone'
  | 'phoneVerified'
  | 'providerId'
  | 'timeZone'
  | 'userName'
  | 'uuid';

type ProfileInterface = {
  active: boolean;
  avatar: string | null;
  created: string;
  createdBy: string | null;
  credentials: string;
  currentPermissions: string[];
  currentRoles: string[];
  discipline: string;
  email: string;
  emailVerified: boolean;
  enableClockInOut: boolean;
  enablePayRate: boolean;
  enablePaycom: boolean;
  enablePto: boolean;
  enableTherapistImport: boolean;
  firstName: string;
  lastName: string;
  licenseNumber: string;
  modified: string;
  modifiedBy: string | null;
  phone: string;
  phoneVerified: boolean;
  providerId: string;
  timeZone: string;
  userName: string;
  uuid: string;
} | null;

function useCurrentUser(inputs: Array<InputType>) {
  const getTherapistProfileData: ProfileInterface = useSelector(
    (state: any) => state.getTherapistProfileReducer.response?.data
  );

  if (!getTherapistProfileData) {
    return inputs.map(() => null);
  }

  return inputs.map((item: InputType) => getTherapistProfileData[item]);
}

export default useCurrentUser;
